/**
 * Contract PDFs are addressed by name in S3, not by a stored key, so this must stay identical
 * to buildContractFileName() on the API side. An amendment shares the mission id with the
 * initial contract: the `_avenant_<n>` segment is the only thing telling the two files apart.
 * Format: contract_<idMission>[_avenant_<n>]_tempworker[_signed]
 */
export const getContractAvenantNumber = (contract) =>
  Number(contract?.avenant_number ?? contract?.avenant ?? 0) || 0;

export const getContractFileName = (idMission, contract) => {
  const avenantNumber = getContractAvenantNumber(contract);
  const avenantSegment = avenantNumber > 0 ? `_avenant_${avenantNumber}` : "";
  const signedSegment = contract?.status === "1" ? "_signed" : "";
  return `contract_${idMission}${avenantSegment}_tempworker${signedSegment}`;
};
